module.exports = __webpack_public_path__ + "static/media/carousel_img5.6160238d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/carousel_img5.jpg
// module id = 367
// module chunks = 0